import React, { useState, useRef, useEffect } from "react";
import Search from "./Search";
import NavLink from "./NavLink";
import Nav from "./Nav";
import { Link, withRouter } from "react-router-dom";
import Constants from "../Constants";
import { Transition } from "react-transition-group";
import Poll from "./Poll";
//import { FiDollarSign } from "react-icons/fi";
function useOutsideAlerter(refs, setOpenMenu, openMenu) {
  useEffect(() => {
    function handleClickOutside(event) {
      if (!openMenu) return;
      // If the click is inside ANY of the refs, do nothing
      const clickedInside = refs.some(
        (ref) => ref.current && ref.current.contains(event.target),
      );
      if (!clickedInside) {
        setOpenMenu(false);
      }
    }

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [refs, openMenu, setOpenMenu]);
}

const Header = ({
  tags,
  display,
  avatar,
  addons,
  history,
  csrf,
  unread,
  isAF,
}) => {
  const [openMenu, setOpenMenu] = useState(false);
  const [showSearch, setShowSearch] = useState(false);
  const [showNetworkSites, setShowNetworkSites] = useState(false);
  const wrapperRef = useRef(null);
  const mobileWrapperRef = useRef(null); // mobile dropdown
  const nodeRef = useRef(null);
  useOutsideAlerter([wrapperRef, mobileWrapperRef], setOpenMenu, openMenu);
  const handleNavigate = (loc) => {
    setOpenMenu(false);
    history.push(`${Constants.HOME}${loc}`);
  };
  return (
    <div className="header_container">
      {showSearch ? <Search setShowSearch={setShowSearch} csrf={csrf} /> : null}

      <div className={openMenu ? "header open" : "header"}>
        <div className="logo">
          <Link to={`${Constants.HOME}`}>
            <strong>NVG</strong>NETWORK
          </Link>
        </div>
        <div className="hold">
          <div className="navigation">
            <NavLink
              to={`${Constants.HOME}`}
              activeOnlyWhenExact={true}
              label="Home"
            />
            <NavLink to={`${Constants.HOME}all-tags`} label="Tags">
              <div className="droppable columns">
                <div className="holder">
                  <h3 className="title">Popular Tags</h3>
                  <ul className="list columns">
                    {tags.map((tag) => (
                      <li className="item_list" key={`poptag${tag.id}`}>
                        <Link
                          to={`${Constants.HOME}tag/${tag.tag_name}/${tag.id}`}
                        >
                          <i className="icon-tag"></i>
                          <div className="name">{tag.tag_name}</div>
                        </Link>
                      </li>
                    ))}
                  </ul>
                  <div className="bottom">
                    <Link to={`${Constants.HOME}all-tags`} className="button">
                      All Tags
                    </Link>
                  </div>
                </div>
              </div>
            </NavLink>
            <NavLink
              to={`${Constants.HOME}girls`}
              activeOnlyWhenExact={true}
              label="Girls"
            />
            <Nav
              to={`${Constants.HOME}network-sites`}
              activeOnlyWhenExact={true}
              label="Network Sites"
            >
              <div className="droppable">
                <div className="holder">
                  <h3 className="title">Our Network Sites</h3>
                  <ul className="list">
                    <li className="item_list">
                      <Link
                        to={`${Constants.HOME}net-video-girls`}
                        className="colorBlue"
                      >
                        <i className="icon-planet"></i>
                        <div className="name">NetVideoGirls.com</div>
                      </Link>
                    </li>
                    <li className="item_list">
                      <Link
                        to={`${Constants.HOME}casting-couch-hd`}
                        className="colorRed"
                      >
                        <i className="icon-planet"></i>
                        <div className="name">CastingCouch-HD.com</div>
                      </Link>
                    </li>
                    <li className="item_list">
                      <Link
                        to={`${Constants.HOME}net-girl`}
                        className="colorOrange"
                      >
                        <i className="icon-planet"></i>
                        <div className="name">NetGirl.com</div>
                      </Link>
                    </li>
                    {isAF && (
                      <li className="item_list">
                        <Link
                          to={`${Constants.HOME}add-friends`}
                          className="colorWhite"
                        >
                          <i className="icon-planet"></i>
                          <div className="name">Add Friends</div>
                        </Link>
                      </li>
                    )}
                    {addons.includes(9) && (
                      <li className="item_list">
                        <a href={`${Constants.API}addon/nvg-art`}>
                          <i className="icon-planet"></i>
                          <div className="name">NVGArt.com</div>
                        </a>
                      </li>
                    )}
                  </ul>
                </div>
              </div>
            </Nav>
            <NavLink
              to={`${Constants.HOME}messages/support`}
              activeOnlyWhenExact={true}
              label="Contact"
            />

            <div className="item">
              <span>
                <a
                  href="https://vip.netvideogirls.com/live-cams/login"
                  alt="Live Net Video Girls!"
                >
                  NVG Live
                </a>
              </span>
            </div>
            <NavLink
              to={`${Constants.HOME}messages`}
              activeOnlyWhenExact={true}
              label="Messages"
              special="colorOrange"
              alert={unread}
            />
            {/* <NavLink
              to={`${Constants.HOME}ideas`}
              activeOnlyWhenExact={true}
              label="Ideas"
              special="colorOrange"
            /> */}
            {/* <div className="item">
              <span>
                <a href="https://vip.netvideogirls.com/friends/">
                  Friends Sites
                </a>
              </span>
            </div> */}
          </div>
        </div>
        <button
          type="button"
          className="button_search"
          onClick={() => setShowSearch(true)}
        >
          <i className="icon-search"></i>
        </button>

        <div className="profile_panel">
          <div
            className="cols"
            onClick={(e) => {
              e.stopPropagation();
              setOpenMenu((prev) => !prev);
            }}
          >
            <div className="col">
              <div className="row">Welcome,</div>
              <div className="row">
                <span className="name">{display}</span>
              </div>
            </div>
            <div className="col second">
              <div className="avatar">
                <img
                  src={`${Constants.STATIC}avatars/${avatar}.jpg`}
                  alt={avatar}
                />
              </div>
            </div>
          </div>
          <div className="dropdown_profile" ref={wrapperRef}>
            <div className="panel_tools">
              <div className="avatar_inner">
                <img
                  src={`${Constants.STATIC}avatars/${avatar}.jpg`}
                  alt={avatar}
                />
              </div>
              <div className="inform">
                <div className="row">
                  <Link to={`${Constants.HOME}profile`} className="name_inner">
                    {display}
                  </Link>
                  <Link to={`${Constants.HOME}profile`} className="setting_btn">
                    <i className="icon-setting"></i>
                  </Link>
                </div>
              </div>
            </div>
            <div className="list_nav">
              <div className="item">
                <Link to={`${Constants.HOME}profile`}>
                  <i className="icon-user"></i>
                  <span>Profile</span>
                </Link>
              </div>
              <div className="item">
                <Link to={`${Constants.HOME}favorites`}>
                  <i className="icon-star-empty"></i>
                  <span>Favorites</span>
                </Link>
              </div>
              {/* <div className="item">
                  <Link to={`${Constants.HOME}paid-videos`}>
                    <i>
                      <FiDollarSign />
                    </i>
                    <span>Paid Videos</span>
                  </Link>
                </div> */}
              <div className="item">
                <a href="https://vip.netvideogirls.com/auth/logout">
                  <i className="icon-logout"></i>
                  <span>Logout</span>
                </a>
              </div>
            </div>
          </div>
        </div>

        <div className="mobile_panel">
          <button
            type="button"
            className="hamburger"
            onClick={(e) => {
              e.stopPropagation();
              setOpenMenu((prev) => !prev);
            }}
          >
            <span></span>
            {unread > 0 && <div className="badge">{unread}</div>}
          </button>
          <div className="dropdown" ref={mobileWrapperRef}>
            <div className="panel_tools">
              <div className="avatar_inner">
                <img
                  src={`${Constants.STATIC}avatars/${avatar}.jpg`}
                  alt="avatar"
                />
              </div>
              <div className="inform">
                <div className="row">
                  <span>Welcome</span>
                  <div className="wrap">
                    <span
                      onClick={() => handleNavigate("profile")}
                      className="name_inner"
                    >
                      {display}
                    </span>
                    <span
                      onClick={() => handleNavigate("profile")}
                      className="setting_btn"
                    >
                      <i className="icon-setting"></i>
                    </span>
                  </div>
                </div>
              </div>
              <button
                type="button"
                className="close_btn"
                onClick={() => setOpenMenu(false)}
              >
                <i className="icon-close"></i>
              </button>
            </div>
            <div className="list_nav">
              <div className="item">
                <span onClick={() => handleNavigate("")}>
                  <span>Home</span>
                </span>
              </div>
              <div className="item">
                <span onClick={() => handleNavigate("all-tags")}>
                  <span>Tags</span>
                </span>
              </div>
              <div className="item nav-highlight">
                <span onClick={() => handleNavigate("girls")}>
                  <span>Girls</span>
                </span>
              </div>
              <div className="item">
                <span onClick={() => setShowNetworkSites((prev) => !prev)}>
                  <span>Network Sites</span>
                </span>
                <Transition
                  in={showNetworkSites}
                  timeout={300}
                  nodeRef={nodeRef}
                >
                  {(state) => (
                    <div className={`item-dropdown quick-${state}`}>
                      <span
                        className="drop-span"
                        onClick={() => handleNavigate("net-video-girls")}
                      >
                        - Net Video Girls
                      </span>
                      <span
                        className="drop-span"
                        onClick={() => handleNavigate("casting-couch-hd")}
                      >
                        - Casting Couch HD
                      </span>
                      <span
                        className="drop-span"
                        style={{ marginBottom: 0 }}
                        onClick={() => handleNavigate("net-girl")}
                      >
                        - Net Girl
                      </span>
                      {isAF && (
                        <span
                          className="drop-span"
                          style={{ marginBottom: 0 }}
                          onClick={() => handleNavigate("add-friends")}
                        >
                          - Add Friends
                        </span>
                      )}
                    </div>
                  )}
                </Transition>
              </div>
              <div className="item">
                <span onClick={() => handleNavigate("messages/support")}>
                  <span>Contact</span>
                </span>
              </div>
              <div className="item">
                <a href="https://vip.netvideogirls.com/live-cams/login">
                  NVG Live
                </a>
              </div>
              <div className="item">
                <span
                  onClick={() => handleNavigate("messages")}
                  className="colorOrange"
                >
                  {unread > 0 ? (
                    <>
                      Messages<small>({unread})</small>
                    </>
                  ) : (
                    "Messages"
                  )}
                </span>
              </div>
              {/* <div className="item">
                  <a href="https://vip.netvideogirls.com/friends/">
                    <span>Friends Sites</span>
                  </a>
                </div> */}
            </div>
            <div className="list_bottom">
              <div className="item">
                <span onClick={() => handleNavigate("profile")}>
                  <i className="icon-user"></i>
                  <span>Profile</span>
                </span>
              </div>
              <div className="item">
                <span onClick={() => handleNavigate("favorites")}>
                  <i className="icon-star-empty"></i>
                  <span>Favorites</span>
                </span>
              </div>
              {/* <div className="item">
                  <span onClick={() => handleNavigate("paid-videos")}>
                    <i>
                      <FiDollarSign />
                    </i>
                    <span>Paid Videos</span>
                  </span>
                </div> */}
              <div className="item">
                <a href="https://vip.netvideogirls.com/auth/logout">
                  <i className="icon-logout"></i>
                  <span>Logout</span>
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
      <Poll csrf={csrf} />
    </div>
  );
};

export default withRouter(Header);
